import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

interface Props {
  serviceTypeId?: number;
  clientId?: number;
  requiresServiceAndClient?: boolean;
  fromTicketFlow?: boolean;
}

function useGetClientStatusList({
  serviceTypeId = null,
  clientId = null,
  requiresServiceAndClient = false,
  fromTicketFlow = false
}: Props = {}) {
  const { showApiError } = useGlobalContext();
  const { catalog: catalogApi } = useApiContext();
  const { t } = useTranslation('global');

  const { data: statusList, isLoading } = useQuery(
    [
      KEYS.catalog.status.getAllStatus(),
      serviceTypeId,
      clientId,
      fromTicketFlow
    ],
    () =>
      catalogApi.status.GetAllStatus({
        onlyEnabled: true,
        serviceTypeId,
        clientId,
        fromTicketFlow
      }),
    {
      refetchOnWindowFocus: false,
      select: ({ data: { data } }) => data,
      enabled: requiresServiceAndClient ? !!serviceTypeId && !!clientId : true,
      onError: (error) => showApiError(error, t('errorMessages.status'))
    }
  );

  return {
    statusList: statusList ?? [],
    isStatusListLoading: isLoading
  };
}

export default useGetClientStatusList;
